import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor(
    private http: HttpClient
  ) { }

  getDataWithSearch(search: string, endpoint: string) {
    return this.http.get<any>(`${environment.baseUrl + endpoint}?search=${search}`);
  }
}
